import { render, staticRenderFns } from "./QuoteSlice.vue?vue&type=template&id=d0c798ba&"
import script from "./QuoteSlice.vue?vue&type=script&lang=js&"
export * from "./QuoteSlice.vue?vue&type=script&lang=js&"
import style0 from "./QuoteSlice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports